import React, { useState, useEffect, Fragment } from 'react';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import RegularButton from 'components/CustomButtons/Button';
import { ConstantPermissions } from 'contexts/useConstant';
import GridContainer from 'components/Grid/GridContainer';
import ClosingLogsModal from './Show/ClosingLogsModal';
import ClosingPayments from './Show/ClosingPayments';
import ClosingDeposits from './Show/ClosingDeposits';
import GridItem from 'components/Grid/GridItem';
import { useParams } from 'react-router-dom';
import { wsGet } from 'services/WService';
import { useModal } from 'hooks/useModal';
import { nDecimal } from 'hooks/Pipe';
import moment from 'moment';

function ClosingShow() {
  const { id } = useParams();

  const [closing, setClosing] = useState();
  const [logModal, setModalOpen] = useModal();

  async function getClosing() {
    let res = await wsGet('pymt/closing', id);
    if (res.success) {
      setClosing(res.data);
    }
  }

  useEffect(() => {
    getClosing();
  }, []);

  if (closing === undefined) {
    return <>Cargando...</>;
  }

  return (
    <Fragment>
      <ClosingLogsModal model={logModal} setOpen={setModalOpen} logs={closing.logs} />
      <CardContainer title={`Cierre de caja ${moment(closing.day).format('DD-MM-YYYY')}`}>
        <GridContainer>
          {/* Zona */}
          <GridItem xl={2} lg={3} md={4} xs={6}>
            <h6>Zona: </h6>
            <h5>{closing.zone.description}</h5>
          </GridItem>
          {/* Estado */}
          <GridItem xl={2} lg={3} md={4} xs={6}>
            <h6>Estado: </h6>
            <h5>{closing.status === 'O' ? 'Abierto' : 'Cerrado'}</h5>
          </GridItem>
          <GridItem xl={2} lg={3} md={4} xs={6}>
            <h6>Hora Apertura: </h6>
            <h5>{closing.start_date || '-'}</h5>
          </GridItem>
          <GridItem xl={2} lg={3} md={4} xs={6}>
            <h6>Hora Cierre: </h6>
            <h5>{closing.end_date || '-'}</h5>
          </GridItem>
          <GridItem xl={2} lg={3} md={4} xs={6}>
            <h6>Abierto por: </h6>
            <h5>{closing.created_by?.name || '-'}</h5>
          </GridItem>
          <GridItem xl={2} lg={3} md={4} xs={6}>
            <h6>Reabierto por: </h6>
            <h5>{closing.updated_by?.name || '-'}</h5>
          </GridItem>
          <GridItem xl={2} lg={3} md={4} xs={6}>
            <h6>Efectivo: </h6>
            <h5>S/ {nDecimal(closing.CashSum)}</h5>
          </GridItem>
          <GridItem xl={2} lg={3} md={4} xs={6}>
            <h6>Cheques: </h6>
            <h5>S/ {nDecimal(closing.CheckSum)}</h5>
          </GridItem>
          <GridItem xl={2} lg={3} md={4} xs={6}>
            <h6>Depositos: </h6>
            <h5>S/ {nDecimal(closing.TrsfrSum)}</h5>
          </GridItem>
          <GridItem xl={2} lg={3} md={4} xs={6}>
            <RegularButton color="warning" onClick={() => setModalOpen()}>
              Logs
            </RegularButton>
          </GridItem>
        </GridContainer>
      </CardContainer>
      <GridContainer>
        <GridItem lg={4} xs={12}>
          <CardContainer title="Pagos recibidos">
            <ClosingPayments
              permission={ConstantPermissions.PYMT_RECEIVED_PAYMENTS_SHOW}
              location="/admin/bancos/datos-maestros/pago-recibidos"
              data={closing.received_payments}
            />
          </CardContainer>
        </GridItem>
        <GridItem lg={4} xs={12}>
          <CardContainer title="Pagos efectuados">
            <ClosingPayments
              permission={ConstantPermissions.PYMT_ACCOMPLISHED_PAYMENTS_SHOW}
              location="/admin/bancos/datos-maestros/pagos-efectuados"
              data={closing.accomplished_payments}
            />
          </CardContainer>
        </GridItem>
        <GridItem lg={4} xs={12}>
          <CardContainer title="Depósitos">
            <ClosingDeposits data={closing.deposits} />
          </CardContainer>
        </GridItem>
      </GridContainer>
    </Fragment>
  );
}

export default ClosingShow;
